/**
 * Shared password policy constants (length, complexity patterns, weak-list thresholds, messages).
 */

export const MIN_PASSWORD_LENGTH = 15;

/** Maximum length for new passwords (storage / UX boundary). */
export const MAX_PASSWORD_LENGTH = 64;

/** At least one lowercase letter. */
export const PASSWORD_COMPLEXITY_LOWERCASE = /[a-z]/;

/** At least one uppercase letter. */
export const PASSWORD_COMPLEXITY_UPPERCASE = /[A-Z]/;

/** At least one digit. */
export const PASSWORD_COMPLEXITY_DIGIT = /\d/;

/** At least one special character. */
export const PASSWORD_COMPLEXITY_SPECIAL = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?£€`~]/;

/** Validation copy: required field. */
export const PASSWORD_ERROR_REQUIRED = 'Password is required.';

/** Validation copy: weak / guessable password. */
export const PASSWORD_ERROR_TOO_COMMON = 'This password is too common or easy to guess. Choose a stronger passphrase.';

/** Validation copy: mixed case. */
export const PASSWORD_ERROR_MIXED_CASE = 'Include both uppercase and lowercase letters.';

/** Validation copy: digit required. */
export const PASSWORD_ERROR_NEED_DIGIT = 'Include at least one number.';

/** Validation copy: special character required. */
export const PASSWORD_ERROR_NEED_SPECIAL = 'Include at least one special character (for example !, @, #, $, %).';

/** Weak list: minimum prefix length for dictionary substring match. */
export const MIN_WEAK_PREFIX_LENGTH = 6;

/** Supplemental tokens merged into public weak-password dictionary (product-specific). */
export const PASSWORD_SUPPLEMENTAL_WEAK_TOKENS = [
  'insightia',
  'diligent',
  'proxyinsight',
  'activistinsight',
  'diligentcorp',
] as const;

/** Minimum run length for ascending/descending digit or letter sequences. */
export const MIN_WEAK_SEQUENCE_RUN = 8;

/** Minimum length of a repeated substring (adjacent duplicate phrase). */
export const MIN_WEAK_REPEAT_UNIT = 4;

/** Minimum same-character run length (e.g. 11111111). */
export const MIN_WEAK_HOMOGENEOUS_RUN = 8;

/** Predictable onboarding / contractor-style substrings. */
export const PASSWORD_PREDICTABLE_HIRE_PATTERN = /new\s*hired?|newhire|sym_newhire|contractor20\d{2}/i;

/** Season / quarter + four-digit year (e.g. Winter2022, Q32024). */
export const PASSWORD_SEASON_QUARTER_YEAR_PATTERN = /(winter|summer|spring|fall|autumn|q[1-4])[^a-z0-9]*20[2-9]\d/i;

/** Product / placeholder org name + four-digit year. */
export const PASSWORD_ORG_NAME_YEAR_PATTERN =
  /(insightia|diligent|proxyinsight|activistinsight|diligentcorp|companyname|acme)[^a-z0-9]*20[2-9]\d/;
